import cc from "classcat"
import { Icon } from "./Icon"

export interface FieldIconProps {
  name: string
  before?: boolean
}

export const FieldIcon = (props: FieldIconProps) => {
  const className = cc(["field__icon", props.before && "field__icon--before"])

  return (
    <div role="presentation" className={className}>
      <Icon name={props.name} />
    </div>
  )
}
